import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';//
import SideBar from './SideBar';
import Loading from './Loading';
import DashboardInfo from './Dashboard.info';
import Pagination from './Pagination';//
import { _formatDateToTextNoneTime } from './Function';
import '../css/Dashboard.css';
import ConditionPage from './Condition';
import axios from 'axios';

class Dashboard extends Component {
  constructor() {
    super();
    this.state={ 
      loadingShow: true,
      dashboard: {},
      is_dashboard: true,
      tel: '',
      mobile: '',
      email: '',
      current_address: {
        c_address_no: '',
        c_address_moo: '',
        c_address_village: '',
        c_address_road: '',
        c_address_soi: '',
        c_district_id: 0,
        c_amphur_id: 0,
        c_province_id: 0,
        c_zipcode: ''
      },
      dateTimeNow:{
        curTime : _formatDateToTextNoneTime(new Date(),''),
      }
    };
    _isLogin().then( value => { 
      if ( value ){
          this.getDividend();
          this.getBeneficiary();
              }
  });
  }

  componentDidMount() {
    // setTimeout(() => this.props.getDashboard());
    this.checkBrowser()
}

checkBrowser(){
    //call check version condition
    axios.post(`https://www.srusct.or.th/APIs/check.show.condition.php`, { member_no : localStorage.getItem('member_no') })
    .then( res => {
        console.log("res.data.isCondition  L LL L L L L ",res)
        console.log('res.data.isCondition ',res.data.isCondition)
       if(res.data.isCondition == true){
           localStorage.setItem('isCheck','false')
       }else{
        return
       }
      // console.log(res.data.condition[0].condition_detail);
      // this.setState({detail:res.data.condition[0].condition_detail})
    })
}

  fallBack = (page) => {
    this.setState({ currentPage: page });
}

getDividend() {
    let param = { token: _getToken(), platform: variable().platform };
    _post('get.dividend.php', param)
    .then(res => { 
        console.log(res)
    //   console.log("getDividend : ",res.data)
        this.setState({ 
            loadingShow: false, 
            is_trans: (res.data.status) ? true : false,
            transaction: res.data.data
        });
        console.log("transaction state : ",this.state.transaction)
        if ( res.data.responseText === 101 ) {
            localStorage.clear();
            _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
        } 
    }).catch(err => { 
        this.setState({ loadingShow: false });
        _Alert('error'); 
    });

}//

getBeneficiary(){
    let param = { token: _getToken(), platform: variable().platform };
    _post('get.beneficiary.php', param)
        .then(res => {

            // console.log("get Ben data ",res)
            this.setState({
                loadingShow: false,
                is_beneficiary: (res.data.status) ? true : false,
                is_benefits_attach  : (res.data.status_attach) ? true : false,
                beneficiary: res.data.beneficiary,
                benefits_attach :res.data.benefits_attach
            });
            console.log("transaction state Ben : ",this.state.beneficiary)
            console.log("transaction state Ben : ",this.state.is_benefits_attach)
       
            if ( res.data.responseText === 101 ) {
                localStorage.clear();
                _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
            }
        }).catch(err => {
        this.setState({ loadingShow: false });
        _Alert('error');
    });
}

renderBeneficiary(){
//   console.log("BEN BEN ",this.state.beneficiary)
    const { rowPerPage, currentPage, transaction } = this.state;
    const indexOfLastTodo = currentPage * rowPerPage;
    const indexOfFirstTodo = indexOfLastTodo - rowPerPage;
    const currentTodos = this.state.beneficiary;
    const is_benefits_attach = this.state.is_benefits_attach;
    if (currentTodos) {
        return (
            <div>
                
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col-sm col-lg col-md">ลำดับ</th>
                            <th scope="col-sm col-lg col-md">ชื่อผู้รับโอนประโยชน์</th>
                            <th scope="col-sm col-lg col-md">สัดส่วน</th>
                            <th scope="col-sm col-lg col-md">ความสัมพันธ์</th>
                        </tr>
                    </thead>
                    <tbody>
                    { currentTodos.map((beneficiary, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{beneficiary.gain_name}</td>
                            <td>{beneficiary.g_share_rate}</td>
                            <td>{beneficiary.relation_name}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>  
                { (is_benefits_attach)?
                <div style={{textAlign: "center"}}>
        <button type="button"  className="btn btn-light btn-lg" onClick={(e) => this.OpenPDF(this.state.benefits_attach)}><span style={{marginRight: "10px"}}><i class="fas fa-search"></i></span>ดูพินัยกรรม</button>
        </div>
        :<div></div>}
    
                { (this.state.beneficiary.length > this.state.rowPerPage) ? <Pagination onSelectPage={this.fallBack} rowPerPage={this.state.rowPerPage} lengths={this.state.beneficiary.length} /> : null }
            </div>
        );
      }
    if(is_benefits_attach){
        return (
        <div style={{textAlign: "center"}}>
        <button type="button"  className="btn btn-light btn-lg" onClick={(e) => this.OpenPDF(this.state.benefits_attach)}><span style={{marginRight: "10px"}}><i class="fas fa-search"></i></span>ดูพินัยกรรม</button>
        </div>
        )
      }
   

}

renderTransaction() {
  console.log("transac : ",this.state.transaction)
    const { rowPerPage, currentPage, transaction } = this.state;
    const indexOfLastTodo = currentPage * rowPerPage;
    const indexOfFirstTodo = indexOfLastTodo - rowPerPage;
    const currentTodos = this.state.transaction;
//   console.log("currentTodos : ",currentTodos)
    return(
        <div>
            <table className="table table-share">
                <thead>
                    <tr>
                    <th scope="col">ปี</th>
                    <th scope="col" className="text-center">เงินปันผล</th>
                    <th scope="col" className="text-center">เฉลี่ยคืน</th>
                    <th scope="col" className="text-center">เฉลี่ยคืนเข้ากองทุน</th>
                    <th scope="col" className="text-center">หมายศาล</th>
                    <th scope="col" className="text-center">ชำระหนี้สหกรณ์</th>
                    <th scope="col" className="text-center">เงินฌาปนกิจ กอง1</th>
                    <th scope="col" className="text-center">เงินฌาปนกิจ กอง2</th>
                    {/* <th scope="col" className="text-center">ของชำร่วย</th>
                    <th scope="col" className="text-center">หักชำระเงินกู้ประเภทเฉพาะกิจ</th>
                    <th scope="col" className="text-center">หักชำระค่าฌาปนกิจ</th> */}
                    <th scope="col" className="text-center">รวมสุทธิ</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentTodos.map((transaction, index) => (
                            <tr key={index}>
                                <td>{transaction.year}</td>
                                <td className="text-center">{transaction.dividend}</td>
                                <td className="text-center">{transaction.dividend_avg}</td>
                                <td className="text-center">{transaction.transfer_fund_value}</td>
                                <td className="text-center">{transaction.subpoena_value}</td>
                                <td className="text-center">{transaction.pay_debt_value}</td>
                                <td className="text-center">{transaction.cremation1_value}</td>
                                <td className="text-center">{transaction.cremation2_value}</td>
                                {/* <td className="text-right">{transaction.gift_varchar}</td>
                                <td className="text-right">{transaction.deduct_type_2}</td>
                                <td className="text-right">{transaction.deduct_type_1}</td> */}
                                <td className="text-center">{transaction.dividend_sum}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            
            <div className="mobile-share-content">
                {
                    currentTodos.map((transaction, index) => (
                        <div key={index} className={(index === 0) ? 'share-loop is-first' : 'share-loop'}>
                            <div className="share-row">
                                <div className="share-row-first"><span className="text-title">ปี : </span><span className="text-desc">{transaction.year}</span></div>
                                <div className="share-row-second"><span className="text-title">เงินปันผล : </span><span className="text-desc">{transaction.dividend} บาท</span></div>
                            </div>
                            <div className="share-row">
                                <div className="share-row-first"><span className="text-title">เฉลี่ยคืน : </span><span className="text-desc">{transaction.dividend_avg} บาท</span></div>
                                <div className="share-row-second"><span className="text-title">เฉลี่ยคืนเข้ากองทุน : </span><span className="text-desc">{transaction.transfer_fund_value} บาท</span></div>
                            </div>
                            <div className="share-row">
                                <div className="share-row-first"><span className="text-title">หมายศาล : </span><span className="text-desc">{transaction.subpoena_value} บาท</span></div>
                                <div className="share-row-second"><span className="text-title">ชำระหนี้สหกรณ์ : </span><span className="text-desc">{transaction.pay_debt_value} บาท</span></div>
                            </div>
                            <div className="share-row">
                                <div className="share-row-first"><span className="text-title">เงินฌาปนกิจ กอง1 : </span><span className="text-desc">{transaction.cremation1_value} บาท</span></div>
                                <div className="share-row-second"><span className="text-title">เงินฌาปนกิจ กอง2 : </span><span className="text-desc">{transaction.cremation2_value} บาท</span></div>
                            </div>
                            <div className="share-row">
                                <div className="share-row-first"><span className="text-title">รวมสุทธิ : </span><span className="text-desc">{transaction.dividend_sum} บาท</span></div>
                            </div>
                        </div> 
                    ))
                }
            </div>

            { (this.state.transaction.length > this.state.rowPerPage) ? <Pagination onSelectPage={this.fallBack} rowPerPage={this.state.rowPerPage} lengths={this.state.transaction.length} /> : null }
        </div>
    )
}

OpenPDF(url){
    // console.log("11111111 : ",url)
    window.open(url,'_system')
}

onLoading = (v) => {
this.setState({ loadingShow: v })
}

update = (t, e) => {
this.setState({ [t]: e.target.value })
}

onAddTime = () => { _setTime() }

render() {
    if( localStorage.getItem("isCheck") == 'true'){
return (
    <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
        <Loading show={this.state.loadingShow} />
        <SideBar onRefresh={false} />

        <div className="content-bar">

        <DashboardInfo onLoading={this.onLoading}/>

        <div className="card">
            <div className="card-title">
            <div className="card-icon"><i className="fas fa-users"></i></div>
            <div className="card-title-text">ผู้รับโอนประโยชน์</div>
            </div>
            <div className="card-content">
                {
                    (this.state.is_beneficiary || this.state.is_benefits_attach) ?
                        this.renderBeneficiary()
                        :
                        <div className="no-data">ไม่พบผู้รับโอนประโยชน์</div>
                }
            </div>
        </div>

        <div className="card">
            <div className="card-title">
            <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
            <div className="card-title-text">เงินปันผลเฉลี่ยคืน</div>
            </div>
            <div className="card-content">
                {
                    (this.state.is_trans) ?
                        this.renderTransaction()
                    :
                        <div className="no-data">ไม่พบเงินปันผลเฉลี่ยคืน</div>
                }              
            </div>
        </div>

        </div>
    </div>
);
    }else{
        return (
        <ConditionPage onCondition='dasboard'/>
        )
    }
}
}
export default Dashboard;